
const digest = 'ed71c87e59368326f06226614bd84ca14410400a418f01936ffb28e30daa3502';
const classes = {"wrapper":"_wrapper_1bpnv_1","content":"_content_1bpnv_8","leftArrow":"_leftArrow_1bpnv_14","rightArrow":"_rightArrow_1bpnv_26","slideWrapper":"_slideWrapper_1bpnv_38"};
const css = `._wrapper_1bpnv_1 {
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  height: 100%;
}
._wrapper_1bpnv_1 ._content_1bpnv_8 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-grow: 1;
}
._wrapper_1bpnv_1 ._content_1bpnv_8 ._leftArrow_1bpnv_14 {
  height: 30px;
  width: 30px;
  background-color: #dbe6f9;
  border-radius: 100%;
  background-image: url("/dist/patientV3/icons/chevron-left-purple.svg");
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-size: 10px;
  margin-top: 175px;
}
._wrapper_1bpnv_1 ._content_1bpnv_8 ._rightArrow_1bpnv_26 {
  height: 30px;
  width: 30px;
  background-color: #dbe6f9;
  border-radius: 100%;
  background-image: url("/dist/patientV3/icons/chevron-right-purple.svg");
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-size: 10px;
  margin-top: 175px;
}
._wrapper_1bpnv_1 ._content_1bpnv_8 ._slideWrapper_1bpnv_38 {
  flex: 1 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  